if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

if (!customElements.get("whatsapp-sticky-contact")) {
  class WhatsAppStickyContact extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
      this.onLocalClick = this.onLocalClick.bind(this);
    }

    connectedCallback() {
      this.details = this.querySelector("details");
      this.summary = this.details?.querySelector("summary");

      if (!this.details || !this.summary) return;

      const oldFloatingButton = document.querySelector("a.whatsapp_floating_button");
      if (oldFloatingButton) oldFloatingButton.style.display = "none";

      document.addEventListener("click", this.onDocumentClick);
      document.addEventListener("keydown", this.onDocumentKeydown);
      this.addEventListener("click", this.onLocalClick);

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener("shopify:block:select", () => {
          this.details.open = true;
        });

        this.addEventListener("shopify:block:deselect", () => {
          this.details.open = false;
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.onDocumentClick);
      document.removeEventListener("keydown", this.onDocumentKeydown);
      this.removeEventListener("click", this.onLocalClick);
    }

    onLocalClick(event) {
      const link = event.target.closest("a.wsc__item");
      if (!link) return;
      this.details.open = false;
    }

    onDocumentClick(event) {
      if (!this.details.open) return;
      if (this.contains(event.target)) return;
      this.details.open = false;
    }

    onDocumentKeydown(event) {
      if (!this.details.open) return;
      if (event.key !== "Escape") return;
      this.details.open = false;
      this.summary.focus();
    }
  }

  customElements.define("whatsapp-sticky-contact", WhatsAppStickyContact);
}
